var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClosefilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 59.5,
    height: 59.5,
    viewBox: "0 0 59.5 59.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{stroke:#fff;stroke-linecap:round;stroke-width:1.5px;}.a{stroke-linejoin:round;fill:url(#a);}.b{fill:none;stroke-miterlimit:10;}.c{filter:url(#b);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1,
    y1: 0.959,
    x2: 0.01,
    y2: 0.037,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7eaeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.123,
    stopColor: "#427bdd",
    stopOpacity: 0.922
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.926,
    stopColor: "#4583ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#759fe6"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 0,
    y: 0,
    width: 59.5,
    height: 59.5,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "c"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.153
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "c"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1215.25 -61.25)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "matrix(1, 0, 0, 1, 1215.25, 61.25)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(15.75 10.75)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1240.565 81.6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,8.669,8.669,0",
    transform: "translate(8.669 0) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,8.669,8.669,0",
    transform: "translate(0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosefilter);
export default __webpack_public_path__ + "static/media/closefilter.b54f3f01600dd508b802efe4e6577d3c.svg";
export { ForwardRef as ReactComponent };